import PinInput from "../Input/PinInput";
import ComponentCard from "../../../../Cards/ComponentCard/ComponentCard"
import classes from "./PinInputList.module.css";

const PinInputList = ({InputPins, polarity, online}) => {
  
  return (
    <ComponentCard>
      <div className={classes["pin-outputs_list"]}>
        <ul>
          {online === "YES" && (
            InputPins.map((inputPin, index) =>
              inputPin.active == 1 && (
                <li key={index}>
                  <PinInput InputPin={inputPin} polarity={polarity} />
                </li>
              )
            )
          )}
        </ul>
      </div>
    </ComponentCard>
  )
}

export default PinInputList;

